import keyMirror from 'keymirror';

export const npsModalActionTypes = keyMirror({
	TOGGLE_NPS_MODAL: null,
	SUBMIT_NPS_MODAL: null,
	SUBMIT_NPS_MODAL_SUCCESS: null,
	SUBMIT_NPS_MODAL_ERROR: null,
	CLEAR_NPS_MODAL_STATE: null,
});

export const stages = ['score', 'comment', 'notification'];
